module.exports = __webpack_public_path__ + "static/media/m9cr93.50de9558.png";